<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
</ng-container>

<!------------------------------

      Table-Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.ssps' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="ssps"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'ssps'">

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.id' | translate }}</th>
      <th>{{ 'lang.globals.ssp' | translate }}</th>
      <th>{{ 'lang.address.address' | translate }}</th>
      <th>{{ 'lang.globals.modifiedAt' | translate }}</th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-ssp>
    <tr>
      <td>
        {{ ssp?.id }}
      </td>
      <td>
        <sb-comp-image-name-wrapper [image]="ssp?.primaryCompany?.logo?.url">
          <span firstLine>{{ ssp?.name }}</span>
          <span secondLine>{{ ssp?.primaryCompany?.identifier }}</span>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        <a *ngIf="ssp?.primaryCompany?.address?.position" class="link" (hidden)="pos = null"
           (shown)="getSelectedLocationCoords(ssp?.primaryCompany)" ngbTooltip
           [sbMapTooltip]="{type: 'Coordinates', data: { x: ssp?.primaryCompany?.address.position.coordinates[0], y: ssp?.primaryCompany?.address.position.coordinates[1] }}"
           tooltipClass="widthFix" placement="right left" container="body" openDelay="300">
          <sb-icon icon="locationStreet" class="mr-2"></sb-icon>
          {{ stringTransformation.addressToString(ssp?.primaryCompany?.address) }}
        </a>
        <span
          *ngIf="!ssp?.primaryCompany?.address?.position"> {{ stringTransformation.addressToString(ssp?.primaryCompany?.address) }}</span>
      </td>
      <td>
        <sb-comp-display-modified [data]="ssp"></sb-comp-display-modified>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper-new>
